import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import Action from 'actions';
import NumberHelper from 'helpers/number-helper';
import InputText from 'components/atoms/inputs/input-text';

class FilterInput extends Component {
    onBlur(rawValue) {
        const value = this.prepareValue(rawValue);

        const {fieldName} = this.props;
        this.props.dispatch(
            Action.set('InnerProjectedOwnershipCap', {
                [fieldName]: value,
            }),
        );
    }

    prepareValue(value) {
        const {projectedOwnershipCap, roundValue = 100, fieldName} = this.props;

        const defaultMin = projectedOwnershipCap.getInnerMin();
        const defaultMax = projectedOwnershipCap.getInnerMax();

        let min = defaultMin;
        let max = defaultMax;
        if ('min' === fieldName) {
            min = projectedOwnershipCap.getOuterMin();
        } else {
            max = projectedOwnershipCap.getOuterMax();
        }

        return NumberHelper.prepareInt(value).limitByRange(min, max, defaultMin, defaultMax).round(roundValue).get();
    }

    render() {
        const {projectedOwnershipCap, fieldName, testId} = this.props;
        const value = projectedOwnershipCap.getInnerCapBoundary(fieldName);

        return <InputText value={value} onBlur={::this.onBlur} keyboard="number" testId={testId} />;
    }
}

function mapStatesToProps(state) {
    const {projectedOwnershipCap} = state;
    return {
        projectedOwnershipCap,
    };
}

export default connect(mapStatesToProps)(FilterInput);
